export default __webpack_public_path__ + "static/media/home-acropass-nidoru.1b2f2816.png";